export const formatCurrentTime = (res: number) => {
  if (!res || Number.isNaN(res)) {
    return res;
  }

  window.PandaNamespace.serverTimeDiff = new Date().getTime() - res;

  return res;
};

export default {
  formatCurrentTime,
};
